<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="{ 'bg-info navbar-dark': type === 'default' }"
  >
    <!-- Search form -->
    <div class="h2 text-white">
    <ul class="navbar-nav align-items-center ml-md-auto">
        <base-dropdown
          menu-on-right
          class="nav-item"
          tag="li"
          title-tag="a"
          title-classes="nav-link pr-0"
        > 
          <a
            href="#"
            class="nav-link pr-0"
            @click.prevent
            slot="title-container"
          >
            <div class="media align-items-center">
              <div class="media-body ml-2 d-none d-lg-block">
                <span class="mb-0 text-sm  font-weight-bold">{{ getUser.FName + ' ' + getUser.LName + '  ' }}({{ getUser.Username }}) -  {{
                  getUser.BranchName
                }}</span>
              </div>
            </div>
          </a> 

          <template>
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">{{ $t("welcome") }}</h6>
            </div>
            <router-link :to="{ name: 'ProfileChange' }">
              <a href="#" class="dropdown-item">
                <i class="ni ni-single-02"></i>
                <span>{{ $t("myprofile") }} </span>
              </a>
            </router-link>
            <router-link :to="{ name: 'ProfileChangePassword' }">
              <a href="#" class="dropdown-item">
                <i class="fa fa-key"></i>
                <span>{{ $t("changepassword") }} </span>
              </a>
            </router-link>
            <div class="dropdown-divider"></div>
            <a href="#!" class="dropdown-item" @click="logout()">
              <i class="ni ni-user-run"></i>
              <span>{{ $t("auth.signout") }}</span>
            </a>
          </template>
        </base-dropdown>
      </ul>
    </div>
    
    
    <!-- Navbar links -->

    <div class="navbar-nav align-items-center ml-md-auto">
      <!-- <base-button
        size="sm"
        type="primary"
        v-if="this.$i18n.locale == 'en'"
        @click="en()"
        >EN</base-button
      >
      <base-button
        size="sm"
        type="neutral"
        v-if="this.$i18n.locale == 'th'"
        @click="en()"
        >EN</base-button
      >
      <base-button
        size="sm"
        type="primary"
        v-if="this.$i18n.locale == 'th'"
        @click="th()"
        >TH</base-button
      >
      <base-button
        size="sm"
        type="neutral"
        v-if="this.$i18n.locale == 'en'"
        @click="th()"
        >TH</base-button
      > -->

      
    </div>
  </base-nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal
  },
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)"
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      getUser: "Auth/getUser"
    }),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: ""
    };
  },
  methods: {
    ...mapActions({
      signOut: "Auth/signOut"
    }),
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout() {
      this.$cookie.delete("token");
      this.signOut();
      this.$router.push("/login");
    },
    th() {
      this.$i18n.locale = "th";
      console.log(this.$i18n.locale);
    },
    en() {
      this.$i18n.locale = "en";
    }
  }
};
</script>
